import logo from "../assets/VardhamanLogo4.jpg"
import { useSelector } from "react-redux";
const LogoLoader = () => {
    const isLoading = useSelector((state) => state.loader.isLoading);
    if (!isLoading) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#FAF8F7]">
            <img
                src={logo}
                alt="Loading..."
                className="w-auto h-24 animate-bounce"
            />
        </div>
    );
};

export default LogoLoader;
